import React, { useContext, useEffect, useState } from "react";
import CustomBreadCrumb from "../../../components/CustomBreadCrumb";
import ReportTemplateDetailSection from "./ReportTemplateDetailsSection";
import { useFormik } from "formik";
import { ACTIONS, TOAST_TYPE, USERTYPES } from "../../../constants/Constants";
import {
  addTabStatusInitialValue,
  editTabStatusInitialValue,
} from "../../User/helpers/InitialData";
import {
  addReportTemplateApi,
  editReportTemplateApi,
  getFirmsList,
  getModalityList,
  getRadiologistList,
  getViewReportTemplateDetail,
} from "../../../service/MasterService";
import toastContext from "../../../context/toast/ToastContext";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import userContext from "../../../context/users/UserContext";
import { useSearchParams } from "react-router-dom";
import { DefaultButton, PrimaryButton } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import { ReportTemplateSchemaForCustomTemplates } from "../../../Schemas/ReportTemplateSchemaForCustomTemplates";
import { ReportTemplateSchemaForAugmentoTemplates } from "../../../Schemas/ReportTemplateSchemaForAugmentoTemplates";
import { ReportTemplateSchemaForClientTemplates } from "../../../Schemas/ReportTemplateSchemaForClientTemplates";
import loaderContext from "../../../context/loader/LoaderContext";

const AddReportTemplate = (props) => {
  const { ref, setLoaderRunning } = useContext(loaderContext);
  const { tabId } = useParams();
  const { state } = useLocation();
  const [modalityList, setModalityList] = useState([]);
  const [radiologistList, setRadiologistList] = useState([]);
  const [firmList, setFirmList] = useState([]);

  const [selectedModality, setSelectedModality] = useState("");
  const [selectedRadiologistId, setSelectedRadiologistId] = useState("");
  const [selectedFirmId, setSelectedFirmId] = useState("");
  const [selectedClientId, setSelectedClientId] = useState("");

  const { showToastv2 } = useContext(toastContext);
  const [isSubmitClicked, setIsSubmitClicked] = useState(true);
  const [isEditClicked, setIsEditClicked] = useState(
    props.action === ACTIONS.EDIT ? true : false
  );
  const [tabStatusInitialValue, setTabStatusInitialValue] = useState(
    props.action === ACTIONS.ADD
      ? addTabStatusInitialValue
      : editTabStatusInitialValue
  );

  const { roles, username, loadByUsername, authenticated, userId, checkForUserAccess } =
    useContext(userContext);
  const { firmId } = useContext(userContext);
  const [searchParams] = useSearchParams();

  const navigate = useNavigate();
  const { t } = useTranslation();

  const getBreadCrumbTitleforAddReportTemplate = () => {
    if (tabId == 3) {
      if (roles[0] === USERTYPES.ADMIN) {
        return t("report-templates.add-firm-template");
      }
    } else if (tabId == 2) {
      return t("report-templates.add-augmento-template");
    } else {
      if (roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.RADIOLOGIST) {
        return t("report-templates.add-custom-template");
      } else {
        return t("report-templates.add-client-template");
      }
    }
  };

  const getBreadCrumbTitleforEditReportTemplate = () => {
    if (tabId == 3) {
      if (roles[0] === USERTYPES.ADMIN) {
        return t("report-templates.edit-firm-template");
      }
    } else if (tabId == 2) {
      return t("report-templates.edit-augmento-template");
    } else {
      if (roles[0] === USERTYPES.ADMIN || roles[0] === USERTYPES.RADIOLOGIST) {
        return t("report-templates.edit-custom-template");
      } else {
        return t("report-templates.edit-client-template");
      }
    }
  };

  const [breadCrumbItems, setBreadCrumBItems] = useState({});

  useEffect(() => {
    checkForUserAccess();
  }, [roles[0]]);

  const getBreadCrumbItems = () => {
    return roles[0] === USERTYPES.ADMIN
      ? [
          {
            text: t("report-templates.list"),
            key: "report_templates",
            href: "/report/list/template/" + tabId,
          },
          {
            text:
              props.action === ACTIONS.ADD
                ? getBreadCrumbTitleforAddReportTemplate()
                : getBreadCrumbTitleforEditReportTemplate(),
            key: "add_report_template",
          },
        ]
      : [
          {
            text: t("report-templates.list"),
            key: "report_templates",
            href: "/report/list/template/" + tabId,
          },
          {
            text:
              props.action === ACTIONS.ADD
                ? getBreadCrumbTitleforAddReportTemplate()
                : getBreadCrumbTitleforEditReportTemplate(),
            key: "add_report_template",
          },
        ];
  };

  const getValidationSchema = (state) => {
    if (props.action === ACTIONS.EDIT) {
      return ReportTemplateSchemaForAugmentoTemplates(t);
    } else {
      if (tabId == 1) {
        if (
          roles[0] === USERTYPES.ADMIN ||
          roles[0] === USERTYPES.RADIOLOGIST
        ) {
          return ReportTemplateSchemaForCustomTemplates(t);
        } else {
          return ReportTemplateSchemaForClientTemplates(t);
        }
      } else if (tabId == 2) {
        return ReportTemplateSchemaForAugmentoTemplates(t);
      } else {
        return ReportTemplateSchemaForClientTemplates(t);
      }
    }
  };

  const initialData = {
    modalityId: 1,
    title: "",
    report: "",
    radiologistId: "",
    templateType: "Common",
    firmId:
      roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR
        ? firmId
        : "",
    clientId: "",
  };

  const {
    dirty,
    values,
    errors,
    touched,
    handleBlur,
    handleChange,
    handleSubmit,
    setValues,
  } = useFormik({
    initialValues: initialData,
    validationSchema: getValidationSchema(state),
    enableReinitialize: true,
    onSubmit: async (values, actions) => {
      const specialUnicodeRegex =
        /[\x00-\x08\x0B\x0C\x0E-\x1F\x7F-\x9F\u200C-\u200F\u2028\u2029]/g;

      if (values.report.match(specialUnicodeRegex)) {
        values.report = values.report.replace(specialUnicodeRegex, "");
        showToastv2(
          TOAST_TYPE.INFO,
          t("string-literals.removed-special-characters")
        );
      }

      if (props.action === ACTIONS.EDIT) {
        if (isEditClicked) {
          let payload = {
            modalityId: values.modalityId,
            title: values.title,
            report: values.report,
            id: values.id,
          };
          editReportTemplate(payload);
        }
      } else {
        if (isSubmitClicked) {
          console.log(values);
          values.radiologistId =
            values.radiologistId == 0 || values.radiologistId == ""
              ? null
              : +values.radiologistId;
          values.firmId =
            values.firmId == 0 || values.firmId == "" ? null : +values.firmId;
          values.clientId =
            values.clientId == 0 || values.clientId == ""
              ? null
              : +values.clientId;

          addReportTemplate(values);
        }
      }
    },
  });

  const handleCancel = () => {
    window.location.href = "/report/list/template/" + tabId;
  };

  const fetchFirmList = async () => {
    const response = await getFirmsList();
    let firmList = [];
    response?.data?.data?.map((firm) => {
      if (firm.id === values.firmId) {
        setSelectedFirmId({
          value: firm.id,
          label: firm.name,
        });
      }

      firmList.push({
        value: firm.id,
        label: firm.name,
      });
    });
    setFirmList(firmList);
  };

  const fetchRadiologistList = async () => {
    const response = await getRadiologistList();
    let radiologistList = [];
    response.data.data.map((radiologist) => {
      if (radiologist.id === values.radiologistId) {
        setSelectedRadiologistId({
          value: radiologist.id + "",
          label: radiologist.firstName + " " + radiologist.lastName,
        });
      }
      radiologistList.push({
        value: radiologist.id + "",
        label: radiologist.firstName + " " + radiologist.lastName,
      });
    });

    setRadiologistList(radiologistList);
  };

  const fetchModalityList = async (id) => {
    const response = await getModalityList();
    let modalityList = [];
    response.data.data.modalityList.map((modality) => {
      if (modality.id === id) {
        console.log(modality);
        setSelectedModality({
          value: modality.id,
          label: modality.name,
        });
      }

      modalityList.push({
        value: modality.id,
        label: modality.name,
      });
    });

    setModalityList(modalityList);
  };

  const fetchReportTemplate = async (reportTemplateId) => {
    const response = await getViewReportTemplateDetail(reportTemplateId);
    let details = response.data.data.editReportTemplateDto;
    console.log(details);
    console.log(details.modalityId != null ? details.modalityId : 1);
    setValues({
      id: reportTemplateId,
      modalityId: details.modalityId != null ? details.modalityId : 1,
      title: details.title != null ? details.title : "",
      report: details.report != null ? details.report : "",
      radiologistId: details.radiologistId != null ? details.radiologistId : "",
      templateType: "Common",
      firmId:
        roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR
          ? firmId
          : details.firmId != null
          ? details.firmId
          : "",
      clientId: details.firmId != null ? details.firmId : "",
    });
    return details;
    // values.id = reportTemplateId;
    // values.modalityId = details.modalityId != null ? details.modalityId : 1;
    // values.title = details.title != null ? details.title : "";
    // values.report = details.report != null ? details.report : "";
    // values.radiologistId =
    //   details.radiologistId != null ? details.radiologistId : "";
    // values.templateType = "Common";
    // values.firmId =
    //   roles[0] === USERTYPES.FIRMADMIN || roles[0] === USERTYPES.SUPERVISOR
    //     ? firmId
    //     : details.firmId != null
    //     ? details.firmId
    //     : "";
    // values.clientId = details.firmId != null ? details.firmId : "";
  };

  const fetchData = async () => {
    setLoaderRunning(true);
    ref.current.continuousStart();
    let data;
    if (props.action === ACTIONS.EDIT) {
      data = await fetchReportTemplate(searchParams.get("id"));
    }
    await fetchModalityList(data?.modalityId ? data?.modalityId : 1);
    // The radiologist picker below only renders for ADMIN, and the API is ADMIN-only, so
    // fetching it as any other role just returns 403 (which logs the user out).
    // OLD: await fetchRadiologistList();
    if (roles[0] === USERTYPES.ADMIN) {
      await fetchRadiologistList();
    } else {
      console.warn("[report-template] skipping radiologist list fetch for role", roles[0]);
    }
    await fetchFirmList();
    setLoaderRunning(false);
    ref.current.complete();
  };

  useEffect(() => {
    if (!authenticated) {
      loadByUsername();
      return;
    }
    fetchData();
    setBreadCrumBItems(getBreadCrumbItems);
  }, [authenticated]);

  useEffect(() => {
    if (roles[0] === USERTYPES.RADIOLOGIST && tabId == 1) {
      setValues({ ...values, radiologistId: userId });
    }
  }, [roles]);

  const addReportTemplate = async (payload) => {
    //proper error messages shown are left
    if (tabId == 1) {
      payload["templateType"] = "Custom";
    } else if (tabId == 2) {
      payload["templateType"] = "Common";
    } else {
      payload["templateType"] = "Client";
    }
    let reportTemplateDto = { addReportTemplateDto: payload };
    try {
      let response = await addReportTemplateApi(reportTemplateDto);
      if (response.status === 200) {
        tabStatusInitialValue.tab2Status = {
          value: "Completed",
          color: "green",
        };
        showToastv2("success", response.data.message);
        setTimeout(() => {
          window.location.href = "/report/list/template/" + tabId;
          tabStatusInitialValue.tab1Status = {
            value: "Info",
            color: "#FF9900",
          };
          tabStatusInitialValue.tab2Status = {
            value: "Info",
            color: "#FF9900",
          };
        }, 2000);
      } else {
        if(response.status === 429){
          showToastv2("error", response?.data?.message);
          return;
        }
        if (response.data.data.errorFields["title"] != undefined) {
          showToastv2("error", response.data.data.errorFields.title);
        }
        if (response.data.data.contains("report")) {
          showToastv2("error", response.data.data.report);
        }
        if (response.data.data.contains("global")) {
          showToastv2("error", response.data.data.global);
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const editReportTemplate = async (payload) => {
    let reportTemplateDto = { editReportTemplateDto: payload };
    try {
      let response = await editReportTemplateApi(reportTemplateDto);
      if (response.data.result === "SUCCESS") {
        if (Object.keys(response.data.data.errorFields).length === 0) {
          tabStatusInitialValue.tab2Status = {
            value: "Completed",
            color: "green",
          };
          showToastv2("success", response.data.message);
          setTimeout(() => {
            window.location.href = "/report/list/template/" + tabId;
            tabStatusInitialValue.tab1Status = {
              value: "Info",
              color: "#FF9900",
            };
            tabStatusInitialValue.tab2Status = {
              value: "Info",
              color: "#FF9900",
            };
          }, 2000);
        } else {
          if (Object.keys(response.data.data.errorFields).includes("title")) {
            errors.title = response.data.data.errorFields["title"];
          }
          if (Object.keys(response.data.data.errorFields).includes("report")) {
            errors.report = response.data.data.errorFields["report"];
          }
          if (
            Object.keys(response.data.data.errorFields).includes("radiologist")
          ) {
            errors.radiologistId =
              response.data.data.errorFields["radiologist"];
          }
          if (Object.keys(response.data.data.errorFields).includes("global")) {
            showToastv2("error", response.data.data.errorFields["global"]);
          }
        }
      }
    } catch (e) {
      console.log(e);
    }
  };

  const handleBeforeSubmit = () => {
    if (props.action === ACTIONS.EDIT) {
      setIsEditClicked(true);
    }
    setIsSubmitClicked(true);
    handleSubmit();
  };

  const editButtons = [
    {
      key: "2",
      button: (
        <DefaultButton
          key="2"
          style={{
            marginLeft: "10px",
          }}
          text={t("button.cancel")}
          onClick={handleCancel}
        />
      ),
    },
    {
      key: "1",
      button: (
        <PrimaryButton
          key="1"
          style={{
            marginLeft: "10px",
          }}
          text={t("button.save")}
          onClick={handleBeforeSubmit}
        />
      ),
    },
  ];

  return (
    <>
      <div className="main-container-body">
        <div className="breadCrumb">
          <CustomBreadCrumb items={breadCrumbItems} />
        </div>
        {/* <TabContainer
          uniqueKey="reportDetails_"
          tabDetails={tabDetails}
          NoOfTabs={tabDetails.length}
          onCancelClick={handleCancel}
          onSubmitClick={handleBeforeSubmit}
          onNextClick={validateTabs}
          onEditClick={() => {
            handleBeforeSubmit();
          }}
          topButtons={editButtons}
          previousNextButton={true}
          mobileTabHeader="Report Templates"
          state={{
            action: ACTIONS.ADD,
          }}
        /> */}
        <div style={{ height: "calc(92% - 60px)", width: "100%" }}>
          <ReportTemplateDetailSection
            key="1"
            handleChange={handleChange}
            values={values}
            handleBlur={handleBlur}
            touched={touched}
            errors={errors}
            modalityList={modalityList}
            radiologistList={radiologistList}
            firmList={firmList}
            action={props.action}
            tabId={tabId}
            userRole={roles[0]}
            setValues={setValues}
            selectedModality={selectedModality}
            selectedFirmId={selectedFirmId}
            selectedRadiologistId={selectedRadiologistId}
            selectedClientId={selectedClientId}
            setSelectedClientId={setSelectedClientId}
            setSelectedModality={setSelectedModality}
            setSelectedRadiologistId={setSelectedRadiologistId}
            setSelectedFirmId={setSelectedFirmId}
          />
        </div>
        <div
          style={{
            height: "60px",
            width: "90%",
            display: "flex",
            alignItems: "center",
            paddingLeft: "40px",
          }}
        >
          {editButtons.map((button) => button.button)}
        </div>
      </div>
    </>
  );
};

export default AddReportTemplate;
